// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__3RZaL","label":"CategoryService_label__201TM","location":"CategoryService_location__3hh51"};